import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  animations: [
    trigger('openClose', [
      // ...
      state('open', style({
        "padding-left": '164px'
      })),
      state('closed', style({
        "padding-left": '0px'
      })),
      transition('open => closed', [
        animate('0.2s')
      ]),
      transition('closed => open', [
        animate('0.2s')
      ]),
    ]),
  ]
})
export class DashboardComponent implements OnInit {

  constructor(
    public globalService: GlobalService,
    private router: Router,
  ) { 
    if(this.globalService.loggedUser){
      if(this.globalService.loggedUser.id_role==96){
        this.router.navigateByUrl("/dashboard/surveys/surveys");
      }
    }
  }

  ngOnInit() {
   
    
  }

}
